<template>
  <div class="route-scroll">
    <pull-refresh v-model="pullLoading" @refresh="refreshList">
      <list v-model="loading" :finished="!hasNext" finished-text="没有更多了" @load="loadList" :immediate-check="false">
        <div style="text-align: center; padding: 10vh 0" v-if="listInfo.length == 0 && !loading"></div>
        <div class="order-list">
          <div class="order-item" v-for="(order, index) in listInfo" :key="index" @click="toDeatil(order)">
            <div class="order-content">
              <div class="order-header">
                <p class="order-time">{{ order.clinicName }}</p>
                <span class="order-status-tag">
                  {{ serviceOrderState.getValueByKey(order.status) }}
                </span>
              </div>
              <div v-for="(product, pIndex) in order.mallOrderDetailVoList" :key="pIndex" class="order-product">
                <div class="order-image">
                  <van-image fit="cover" :src="product.goodsIcon" :alt="product.goodsName" class="order-avatar" />
                </div>
                <div class="order-info">
                  <drugTag :product="product" />
                  <p class="order-description">{{ product.description }}</p>
                </div>
                <p class="order-price">￥{{ product.totalAmount }}</p>
              </div>
              <div class="order-summary">
                <p></p>
                <p>
                  合计：<span class="total-price">￥{{ order.payAmount }}</span>
                </p>
              </div>
              <div class="panel-foot">
                <div class="panel-left">{{ order.createTime }}</div>
                <div class="panel-right">
                  <!-- <div class="pay-btn" @click.stop="toDeatil(order)" v-if="order.status === '0'">去支付</div> -->
                  <div class="pay-btn cancel-btn" @click.stop="cancel(order)" v-if="['0', '1'].includes(order.status)">
                    取消订单
                  </div>
                  <div class="pay-btn" @click.stop="logistics(order)" v-if="order.expressNo">查看物流</div>
                  <div class="pay-btn rx-btn" @click.stop="toPrescription(order)" v-if="showPerBtn(order)">
                    去开方
                  </div>
                  <div class="pay-btn" @click.stop="toDeatil(order)" v-if="showPayBtn(order)">去支付</div>
                  <!-- <div class="pay-btn" @click.stop="bind(order)" v-if="!order.clinicName">
                    绑定诊所
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </list>
    </pull-refresh>
    <!-- <setClinic ref="setClinic" @selected="submitBind" /> -->
  </div>
</template>

<script>
import drugTag from '@/components/drugTag';

import services from '@/service';
import { PullRefresh, List, Image as VanImage } from 'vant';
// import { mapGetters } from 'vuex';
import { wxAuthTo, mallPrescriptionInit, onlineCheck } from '@/lib/utils';
// import setClinic from './components/setClinic';

import { serviceOrderStateAll } from '@/enum/index';

export default {
  name: 'mallMyOrder',
  components: { drugTag, PullRefresh, List, VanImage },
  data() {
    return {
      orders: [],
      pullLoading: false,
      loading: false,
      hasNext: true,
      queryParams: {
        pageNum: 0,
        pageSize: 10
      },
      listInfo: [],
      serviceOrderState: {},
      setClinicShow: false,
      curServiceOrderId: ''
    };
  },
  computed: {
    rxSuccess() {
      return this.$route.query.rxSuccess === '1';
    }
  },
  async mounted() {
    this.pageInit();
  },
  activated() {
    // const mallPrescriptionState = localStorage.getItem('mallPrescriptionState');
    // const needHistoryReplace = localStorage.getItem('needHistoryReplace');
    // if (mallPrescriptionState) {
    //   console.log('mallPrescriptionState:', mallPrescriptionState);
    //   localStorage.removeItem('mallPrescriptionState');
    //   this.$router.push({
    //     name: 'mallPrescription',
    //     query: {
    //       state: mallPrescriptionState
    //     }
    //   });
    // } else if (needHistoryReplace && !this.rxSuccess) {
    //   console.log('not rxSuccess');
    //   localStorage.removeItem('needHistoryReplace');
    //   localStorage.removeItem('mallPrescriptionOrderId');
    //   window.history.replaceState(null, '', '/mall-personal');
    //   window.history.pushState(null, '', this.$route.fullPath);
    //   this.dataInit();
    // }
  },
  methods: {
    pageInit() {
      console.log('pageInit');
      const mallPrescriptionState = localStorage.getItem('mallPrescriptionState');
      const mallPrescriptionUrl = localStorage.getItem('mallPrescriptionUrl');
      const needHistoryReplace = localStorage.getItem('needHistoryReplace');
      const mallPrescriptionOrderId = localStorage.getItem('mallPrescriptionOrderId');
      const mallOrderId = localStorage.getItem('mallOrderId');

      if (mallPrescriptionState) {
        console.log('mallPrescriptionState:', mallPrescriptionState);
        localStorage.removeItem('mallPrescriptionState');
        this.$router.push({
          name: 'mallPrescription',
          query: {
            state: mallPrescriptionState
          }
        });
      } else if (mallPrescriptionUrl) {
        console.log('mallPrescriptionUrl:', mallPrescriptionUrl);
        localStorage.removeItem('mallPrescriptionUrl');
        localStorage.setItem('needHistoryReplace', 'true');
        window.location.href = mallPrescriptionUrl;
      } else if (needHistoryReplace && this.rxSuccess) {
        console.log('needHistoryReplace:', needHistoryReplace);
        localStorage.removeItem('needHistoryReplace');
        localStorage.removeItem('mallPrescriptionOrderId');
        window.history.replaceState(null, '', '/mall-personal');
        window.history.pushState(null, '', this.$route.fullPath);
        // this.$router.push({
        //   name: 'mallPrescriptionDetail',
        //   query: {
        //     id: mallPrescriptionOrderId
        //   }
        // });
        this.toDeatil({ mallOrderId: mallPrescriptionOrderId, autoPay: '1' });
      } else if (mallOrderId) {
        localStorage.removeItem('mallOrderId');
        this.toDeatil({ mallOrderId: mallOrderId, autoPay: '1' });
      } else if (!this.listInfo.length) {
        console.log('getListInfo');
      }
      this.dataInit();
    },
    async dataInit() {
      this.serviceOrderState = await serviceOrderStateAll();
      this.refreshList();
    },
    toDeatil(item) {
      wxAuthTo({
        routerName: 'mallOrderDetail',
        query: {
          orderCode: item.orderCode,
          serviceOrderId: item.mallOrderId,
          autoPay: item.autoPay || '0'
        }
      });
    },
    async toPrescription(item) {
      await onlineCheck();
      mallPrescriptionInit(item.mallOrderDetailVoList, item.mallOrderId, 'push');
    },
    showPerBtn(order) {
      return order.rxFlag === '1' && !order.rxId && ['0'].includes(order.status);
    },
    showPayBtn(order) {
      let tag = false;
      const canPay = ['0'].includes(order.status);
      const hasRx = order.rxFlag === '1';
      if (canPay) {
        if (hasRx && order.rxStatus === '2') {
          tag = true;
        } else if (!hasRx) {
          tag = true;
        }
      }
      return tag;
    },
    cancel(item) {
      this.$dialog
        .confirm({
          title: '提示',
          message: '请确认是否取消订单？'
        })
        .then(async () => {
          await services.mall.cancelOrder(item.mallOrderId);
          this.$toast('取消成功');
          item.status = this.serviceOrderState.getKeyByValue('已取消');
        });
    },
    logistics(item) {
      this.$router.push({
        name: 'mallLogistics',
        query: {
          id: item.mallOrderId
        }
      });
    },
    async bind(item) {
      this.curServiceOrderId = item.serviceOrderId;
      this.$refs.setClinic.visible = true;
    },
    async submitBind(params) {
      await services.mall.orderBindClinic({ ...params, serviceOrderId: this.curServiceOrderId });
      this.$toast.success('绑定成功');
      this.refreshList();
    },
    async refreshList() {
      this.pullLoading = true;
      this.listInfo = [];
      this.queryParams.pageNum = 0;
      this.hasNext = false;
      setTimeout(() => {
        this.loadList();
      }, 500);
    },
    async loadList() {
      this.queryParams.pageNum++;

      const res = await services.mall.orderList({ ...this.queryParams });
      this.listInfo = [...this.listInfo, ...res.rows];
      this.hasNext = this.listInfo.length < res.total;
      this.pullLoading = false;
      this.loading = false;
      // this.$store.dispatch('subLoading');
    }
  }
};
</script>

<style lang="scss" scoped>
.order-item {
  background: #fff;
  padding: 12px;
  margin: 8px 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.order-time {
  font-size: 13px;
  font-weight: 500;
  color: #666;
  letter-spacing: 0.2px;
}

.order-status-tag {
  font-size: 13px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  background: rgba($appcolor, 0.1);
  color: $appcolor;
}

.order-product {
  display: flex;
  margin-bottom: 8px;
  padding: 6px;
  border-radius: 6px;
  transition: background-color 0.3s ease;
  align-items: flex-start;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
}

.order-image {
  width: 70px;
  height: 70px;
  margin-right: 12px;
  position: relative;
  border-radius: $radius;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.order-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.order-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  padding-right: 8px;
}

.order-name {
  margin-bottom: 4px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 4px;

  :deep(.drug-tag) {
    flex-shrink: 0;
    margin-top: 2px;
  }
}

.order-description {
  color: #999;
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 4px;
  @include hiddenText();
}

.order-price {
  font-size: 14px;
  font-weight: 600;
  color: #ff4d4f;
  flex-shrink: 0;
  margin-left: 8px;
  white-space: nowrap;
}

.order-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.04);
}

.total-price {
  font-size: 16px;
  font-weight: 600;
  color: #ff4d4f;
}

.panel-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  margin-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.04);

  .panel-left {
    font-size: 12px;
    color: #999;
  }

  .panel-right {
    display: flex;
    gap: 8px;
  }
}

.pay-btn {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid $appcolor;
  color: $appcolor;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    transform: scale(0.98);
  }
}

.cancel-btn {
  border: 1px solid $gray2;
  color: $gray2;
}

.rx-btn {
  border: 1px solid #ff6034;
  color: #ff6034;
}

// 状态颜色
.status-pending {
  color: #faad14;
  background: rgba(250, 173, 20, 0.1);
}

.status-shipped {
  color: #52c41a;
  background: rgba(82, 196, 26, 0.1);
}
</style>
